import { render, staticRenderFns } from "./RealEstateKindsAppraisals.vue?vue&type=template&id=7534cb56&scoped=true&"
import script from "./RealEstateKindsAppraisals.vue?vue&type=script&lang=js&"
export * from "./RealEstateKindsAppraisals.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateKindsAppraisals.vue?vue&type=style&index=0&id=7534cb56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7534cb56",
  null
  
)

export default component.exports